import React from 'react'

const EtAdminTrafficAnalytics = () => {
  return (
    <div>EtAdminTrafficAnalytics</div>
  )
}

export default EtAdminTrafficAnalytics